import { render, staticRenderFns } from "./RowBlockPaymentSystemCommissionHostPay.vue?vue&type=template&id=bda7709e&"
import script from "./RowBlockPaymentSystemCommissionHostPay.vue?vue&type=script&lang=js&"
export * from "./RowBlockPaymentSystemCommissionHostPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports